import script from "./Analytics.vue?vue&type=script&setup=true&lang=js"
export * from "./Analytics.vue?vue&type=script&setup=true&lang=js"

import "./Analytics.vue?vue&type=style&index=0&id=65d0c6c1&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65d0c6c1"]])

export default __exports__